export default __webpack_public_path__ + "static/media/rain-day.b8b5edb7.svg";